(function () {
  "use strict";

  var DEFAULT_FAQS = [
    { q: "resistance weight kg", a: "IronVX delivers 0–40 kg stepless resistance. Each side adjusts 0.5–20 kg with one-tap sync." },
    { q: "app required phone", a: "The device provides onboard controls. Check the product page or ask support for current app features and compatibility." },
    { q: "mount wall floor", a: "Review the supplied setup instructions and current product page before mounting or anchoring the device." },
    { q: "portable travel suitcase", a: "IronVX is designed to be compact and portable. Check the current product specifications before planning luggage or travel." },
    { q: "kids elderly safe", a: "Exercise equipment requires safe setup and appropriate supervision. Ask a qualified professional before use by children, older adults, or anyone with a medical condition." },
    { q: "box included", a: "See the live product page for current bundle contents and optional accessories." },
    { q: "warranty", a: "Review the current written warranty terms or email info@ironvx.com before ordering." },
    { q: "price cost buy", a: "See live pricing on our product page." },
    { q: "shipping delivery", a: "Shipping availability, cost, and timing are shown for your destination at checkout." },
    { q: "return refund", a: "Review the current Refund Policy or contact info@ironvx.com before sending anything back." },
    { q: "contact support email", a: "Email us at info@ironvx.com." },
    { q: "modes training", a: "Review the product page for the current list of training modes." },
    { q: "noise loud quiet", a: "IronVX uses motor-controlled digital resistance. Actual sound varies by movement, resistance, surface, and room." },
    { q: "battery plug charge", a: "Review the current product specifications and included adaptor details on the product page." }
  ];

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function readChatData() {
    var el = $("#ironvx-chat-data");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyPlaceholders(text, data) {
    var out = String(text || "");
    if (!data) return out;
    out = out.split("{{product_url}}").join(data.productUrl || "");
    out = out.split("{{support_email}}").join(data.supportEmail || "info@ironvx.com");
    out = out.split("{{contact_email}}").join(data.contactEmail || "info@ironvx.com");
    return out;
  }

  function parseFaqs(raw, data) {
    var lines = String(raw || "")
      .split(/\r?\n/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    if (!lines.length) return null;

    var faqs = [];
    lines.forEach(function (line) {
      var sep = line.indexOf("|");
      if (sep === -1) return;
      var q = line.slice(0, sep).trim();
      var a = applyPlaceholders(line.slice(sep + 1).trim(), data);
      if (q && a) faqs.push({ q: q, a: a });
    });

    return faqs.length ? faqs : null;
  }

  function kbWithContext(root) {
    var data = readChatData();
    var faqs = parseFaqs(data && data.faqRaw, data) || DEFAULT_FAQS.map(function (faq) {
      return {
        q: faq.q,
        a: applyPlaceholders(faq.a, data || {
          productUrl: root && root.dataset.productUrl,
          supportEmail: root && root.dataset.supportEmail,
          contactEmail: root && root.dataset.contactEmail
        })
      };
    });

    var fallback = (data && data.fallback) ||
      "I can help with IronVX specs, pricing, shipping, returns, and warranty. What would you like to know?";

    return { faqs: faqs, default: applyPlaceholders(fallback, data) };
  }

  function findLocalAnswer(query, root) {
    var KB = kbWithContext(root);
    var q = String(query || "").toLowerCase();
    var words = q.replace(/[^a-z0-9\s$./-]/g, " ").split(/\s+/).filter(function (w) {
      return w.length > 2;
    });
    var best = null;
    var bestScore = 0;

    KB.faqs.forEach(function (faq) {
      var hay = (faq.q + " " + faq.a).toLowerCase();
      var score = 0;
      words.forEach(function (w) {
        if (hay.indexOf(w) !== -1) score += 1;
      });
      if (score > bestScore) {
        bestScore = score;
        best = faq.a;
      }
    });

    if (bestScore >= 2 && best) return best;

    var i;
    for (i = 0; i < KB.faqs.length; i += 1) {
      var keys = KB.faqs[i].q.toLowerCase().split(/[\s,|/]+/).filter(Boolean);
      for (var k = 0; k < keys.length; k += 1) {
        if (keys[k].length > 2 && q.indexOf(keys[k]) !== -1) return KB.faqs[i].a;
      }
    }

    return KB.default;
  }

  function initChat() {
    var root = $("#ironvx-chat");
    if (!root || root.dataset.enabled !== "true") return;

    if (document.querySelector(".ironvx-product-page")) {
      root.classList.add("ironvx-chat--shifted");
    }

    var panel = $("#ironvx-chat-panel");
    var toggle = $("#ironvx-chat-toggle");
    var closeBtn = $("#ironvx-chat-close");
    var form = $("#ironvx-chat-form");
    var input = $("#ironvx-chat-input");
    var messages = $("#ironvx-chat-messages");
    var apiUrl = (root.dataset.apiUrl || "").replace(/\/$/, "");
    var history = [];

    function scrollBottom() {
      if (!messages) return;
      messages.scrollTop = messages.scrollHeight;
    }

    function addMessage(role, text) {
      if (!messages) return;
      var wrap = document.createElement("div");
      wrap.className = "ironvx-chat-msg ironvx-chat-msg--" + role;
      var bubble = document.createElement("div");
      bubble.className = "ironvx-chat-bubble";
      bubble.textContent = text;
      wrap.appendChild(bubble);
      messages.appendChild(wrap);
      scrollBottom();
    }

    function setTyping(on) {
      var el = $("#ironvx-chat-typing");
      if (el) el.hidden = !on;
      scrollBottom();
    }

    function openPanel() {
      if (!panel) return;
      panel.hidden = false;
      toggle.setAttribute("aria-expanded", "true");
      input.focus();
    }

    function closePanel() {
      if (!panel) return;
      panel.hidden = true;
      toggle.setAttribute("aria-expanded", "false");
      toggle.focus();
    }

    function replyFor(query) {
      if (apiUrl) {
        history.push({ role: "user", content: query });
        return fetch(apiUrl + "/api/chat", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ messages: history })
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw new Error(data.error || "Chat failed");
              return data.reply;
            });
          })
          .then(function (reply) {
            history.push({ role: "assistant", content: reply });
            if (history.length > 20) history = history.slice(-20);
            return reply;
          })
          .catch(function () {
            return findLocalAnswer(query, root);
          });
      }
      return Promise.resolve(findLocalAnswer(query, root));
    }

    function sendMessage(text) {
      var query = String(text || "").trim();
      if (!query) return;
      addMessage("user", query);
      input.value = "";
      setTyping(true);
      replyFor(query)
        .then(function (reply) {
          addMessage("assistant", reply);
        })
        .finally(function () {
          setTyping(false);
        });
    }

    toggle.addEventListener("click", function () {
      if (panel.hidden) openPanel();
      else closePanel();
    });
    closeBtn.addEventListener("click", closePanel);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      sendMessage(input.value);
    });

    root.querySelectorAll("[data-ironvx-chat-suggest]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openPanel();
        sendMessage(btn.getAttribute("data-ironvx-chat-suggest"));
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel && !panel.hidden) closePanel();
    });
  }

  document.addEventListener("DOMContentLoaded", initChat);
})();
